import IMLSPhotos from './IMLSPhotos';
import IMLSData from './IMLSData';

/**
 * A single MLS property. The fields property is a MLSData array.
 */
export default interface IMLSPropertyItem {
    fields: IMLSData[];
    mediaUrls?: IMLSPhotos[];
}

export function newMlsPropertyItem(): IMLSPropertyItem {
    const propertyItem: IMLSPropertyItem = {
        fields: [],
        mediaUrls: []
    };
    return propertyItem;
}
